<section class="root">
  <div class="video-grid">
    <!-- For each video in the list, create a thumbnail -->
    @for (video of displayedVideoSearchResultListPaginated.videos; track $index)
    {
    <div class="video-grid__item">
      <div class="video-card">
        <app-video-card [video]="video"></app-video-card>
      </div>
    </div>
    }
  </div>
</section>
